import { FormControlLabel, Radio, Typography } from '@mui/material';
import type { PlanCreateReason } from 'apps/app/src/contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import React from 'react';

type PlanCreationReasonOptionProps = {
  value: PlanCreateReason;
  title: string;
  description: string;
};
  
export const MenuItemPlanCreationReasonOption: React.FC<PlanCreationReasonOptionProps> = ({ value, title, description }) => (
  <>
    <FormControlLabel
      value={value}
      control={<Radio />}
      sx={{ padding: '10px' }}
      className="flex items-start"
      label={
        <section className="pt-2">
          <Typography
            variant="body1"
            fontWeight={350}
            color="black"
            fontFamily="OakesGrotesk"
            fontSize='16px'
            lineHeight="24px"
          >
            {title}
          </Typography>
          <Typography
            variant='subtitle1'
            fontWeight={500}
            fontSize='16px'
            lineHeight="28px" 
            className="text-[#A3ACBD]"
          >
            {description}
          </Typography>
        </section>
      }
    />
  </>
);